export const SLIDE_CONTAINER_SIZE = 118;
export const ITEMS_PER_CONTAINER = 4;
